

export const regionService = "AdministrationBoundary:Ethio_Regions";
export const zoneService = "AdministrationBoundary:Ethio_Zones";
export const woredaService = "AdministrationBoundary:Ethio_Woredas";

export const DEFAULT_CENTER: [number, number] = [9.005401, 38.763611];
export const DEFAULT_ZOOM = 7;
export const MARKER_ICON_PATH = "/assets/cewrs/images/LocationIcon.png";

export const PERMISSIONS = {
    // Incident Permissions
    INCIDENTS_CREATE: 'incidents:create',
    INCIDENTS_READ: 'incidents:read',
    INCIDENTS_UPDATE: 'incidents:update',
    INCIDENTS_UPDATE_STATUS: 'incidents:update:status',
    INCIDENTS_ESCALATE: 'incidents:escalate',
    INCIDENTS_DELETE: 'incidents:delete',
    INCIDENT_STATUSES: 'incident-statuses',
    INCIDENTS_DE_ESCALATE: 'incidents:de_escalate',
    INCIDENTS_MOP_REVIEW: 'incidents:mop-review',
    INCIDENTS_GIS_REVIEW: 'incidents:gis-review',
    INCIDENTS_MOP_APPROVE: 'incidents:mop-approve',
    INCIDENTS_ASSIGN_ANALYSIS: 'incidents:assign-analysis',
    INCIDENTS_SUBMIT_ANALYSIS: 'incidents:submit-analysis',
    INCIDENTS_MANAGE_ANALYSIS_FORM: 'incidents:manage-analysis-form',
    INCIDENTS_MANAGE_GIS_FORM: 'incidents:manage-gis-form',
    INCIDENTS_SUSPEND: 'incidents:suspend',
    INCIDENTS_CM_LEO_APPROVE: 'incidents:cm-leo-approve',
    DISSEMINATE_TO_REGION: 'disseminate:region',
    DISSEMINATE_TO_FEDERAL: 'disseminate:federal',
    INCIDENTS_CLOSE: 'incidents:close',

    // Admin Permissions
    ADMIN_BLACKLIST_MANAGE: 'admin:blacklist:manage',
    ADMIN_TEAMS_MANAGE: 'admin:teams:manage',
    ADMIN_ROLES_MANAGE: 'admin:roles:manage',
    ADMIN_PERMISSIONS_MANAGE: 'admin:permissions:manage',
    ADMIN_BASEDATA_MANAGE: 'admin:base-data:manage',
    ADMIN_AUDIT_LOGS_VIEW: 'admin:audit-logs:view',
    ADMIN_USERS_MANAGE: 'admin:users:manage',
    ADMIN_UNASSIGN_USER_ROLE: 'admin:users:unassign-role',
    ADMIN_ASSIGN_USER_ROLE: 'admin:users:assign-role',
    ADMIN_WORKFLOW_MANAGE: 'admin:workflow:manage',
    ADMIN_SUPER: 'admin:super',
    FEEDBACK_CREATE: 'feedback:create',
    FEEDBACK_RESPOND: 'feedback:respond',
    FEEDBACK_READ: 'feedback:read',

    //Reports
    REPORTS_READ: 'reports:read',
    REPORTS_CREATE: 'reports:create',
    REPORTS_READ_OWN: 'reports:read:own',
    REPORTS_PROMOTE: 'reports:promote',
    REPORTS_DISMISS: 'reports:dismiss',
    REPORTS_CONFIRM: 'report:confirm',
    PASS_REPORT_TO_REGION: 'report:pass',


    // Triangulations Permissions

    TRIANGULATIONS_START: 'triangulations:start',
    TRIANGULATIONS_READ: 'triangulations:read',
    TRIANGULATIONS_RECOMMEND: 'triangulations:recommend',
    TRIANGULATIONS_FINALIZE: 'triangulations:finalize',


    USER_DELETE: 'users:delete',
    USER_UPDATE: 'users:update',
    USER_READ: 'users:read',

    TASK_CREATE: 'tasks:create',
    DELEGATION_MANAGE: 'delegation:manage',
    RISK_SCORE_READ: 'risk-score:read',
    RISK_SCORE_MANAGE: 'risk-score:manage',
    MOP_TEAM: 'mop:team',
    DASHBOARD_VIEW: 'dashboard:view',
    DIRECT_MESSAGES_MANAGE: 'direct:messages:manage',
};